module.exports = __webpack_public_path__ + "img/2.4075e3af.jpg";